<template>
  <div>
    <div
      v-if="file.success"
      class="text-success font-weight-bold"
      title="Uploaded"
    >✓</div>
    <div
      v-else-if="file.error"
      class="text-danger font-weight-bold"
      :title="`Error: ${file.error}`"
    >✗</div>
  </div>
</template>

<script>
  export default {
    name: 'UploadIndicator',
    props: {
      file: {
        type: Object,
        default: () => ({}),
      }
    },
  }
</script>
